module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_Avans_image_3.9f2615a4.jpg";